// assets
import { CodeOutlined } from '@ant-design/icons';
import { NavGroupType } from './types';

// icons
const icons = {
    CodeOutlined,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const cronjob: NavGroupType = {
    id: 'group-cronjob',
    title: 'menu.cronjob.title',
    type: 'group',
    children: {} as { [key: string]: any },
    disabled: {
        qlive_cronjob_cronjob_list: {
            id: 'list-cronjobs',
            title: 'menu.cronjob.items.list',
            type: 'item',
            url: '/cronjob',
            icon: icons.CodeOutlined,
            breadcrumbs: false,
        },
    },
};

export default cronjob;
